import { 
    FETCH_ALL_USERS,
    FETCH_ALL_USERS_SUCCESS,
    FETCH_ALL_USERS_FAILED,
    DELETE_USER_FAILED,
    CLEAR_USERS_ERROR,
    FETCH_ALL_USERS_STATIC,
    FETCH_ALL_USERS_STATIC_SUCCESS,
    FETCH_ALL_USERS_STATIC_FAILED,
    EDIT_USER,
    FETCH_ALL_DRIVERS,
    FETCH_ALL_DRIVERS_SUCCESS,
    FETCH_ALL_DRIVERS_FAILED,
    PATCH_USER_IN_LIST,
    REMOVE_USER_FROM_LIST,
    DELETE_USER_SUCCESS,
    FETCH_USERS_PAGE,
    FETCH_USERS_PAGE_SUCCESS,
    FETCH_USERS_PAGE_FAILED,
    RESET_USERS_PAGE,
  } from "../store/types";

  const emptyUsersPageBucket = () => ({
    items: [],
    hasMore: true,
    lastKey: null,
    loading: false,
    error: null,
  });

  const patchUserInLists = (state, user) => {
    if (!user || !user.id) return state;

    const patchList = (list) => {
      if (!list || !Array.isArray(list)) return list;
      const idx = list.findIndex((entry) => entry.id === user.id);
      if (idx >= 0) {
        const next = [...list];
        next[idx] = { ...next[idx], ...user };
        return next;
      }
      return [...list, user];
    };

    const patchUsersPages = (usersPage) => {
      if (!usersPage) return usersPage;
      const next = { ...usersPage };
      Object.keys(next).forEach((key) => {
        const bucket = next[key];
        if (!bucket || !Array.isArray(bucket.items)) return;
        const idx = bucket.items.findIndex((entry) => entry.id === user.id);
        if (idx >= 0) {
          const items = [...bucket.items];
          items[idx] = { ...items[idx], ...user };
          next[key] = { ...bucket, items };
        }
      });
      return next;
    };

    return {
      ...state,
      staticusers: patchList(state.staticusers),
      users: patchList(state.users),
      usersPage: patchUsersPages(state.usersPage),
    };
  };

  const removeUserFromLists = (state, uid) => {
    if (!uid) return state;

    const filterList = (list) =>
      list && Array.isArray(list) ? list.filter((entry) => entry.id !== uid) : list;

    const filterUsersPages = (usersPage) => {
      if (!usersPage) return usersPage;
      const next = { ...usersPage };
      Object.keys(next).forEach((key) => {
        const bucket = next[key];
        if (!bucket || !Array.isArray(bucket.items)) return;
        next[key] = {
          ...bucket,
          items: bucket.items.filter((entry) => entry.id !== uid),
        };
      });
      return next;
    };

    return {
      ...state,
      staticusers: filterList(state.staticusers),
      users: filterList(state.users),
      usersPage: filterUsersPages(state.usersPage),
    };
  };
  
  export const INITIAL_STATE = {
    users:null,
    staticusers:null,
    drivers: null,
    usersPage: {},
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const usersreducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ALL_USERS:
        return {
          ...state,
        };
      case FETCH_ALL_USERS_SUCCESS:
        return {
          ...state,
          users:action.payload,
        };
      case FETCH_ALL_USERS_FAILED:
        return {
          ...state,
          users:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case FETCH_ALL_DRIVERS:
        return {
          ...state
        };
      case FETCH_ALL_DRIVERS_SUCCESS:
        return {
          ...state,
          drivers:action.payload
        };
      case FETCH_ALL_DRIVERS_FAILED:
        return {
          ...state,
          drivers:null,
          error:{
            flag:true,
            msg:action.payload
          }
        };  
      case FETCH_ALL_USERS_STATIC:
        return {
          ...state,
          loading:true
        };
      case FETCH_ALL_USERS_STATIC_SUCCESS:
        return {
          ...state,
          staticusers:action.payload,
          loading:false
        };
      case FETCH_ALL_USERS_STATIC_FAILED:
        return {
          ...state,
          staticusers:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case RESET_USERS_PAGE: {
        const pageKey = action.payload;
        return {
          ...state,
          usersPage: {
            ...state.usersPage,
            [pageKey]: emptyUsersPageBucket(),
          },
        };
      }
      case FETCH_USERS_PAGE: {
        const { pageKey } = action.payload;
        const current = state.usersPage[pageKey] || emptyUsersPageBucket();
        return {
          ...state,
          usersPage: {
            ...state.usersPage,
            [pageKey]: {
              ...current,
              loading: true,
              error: null,
            },
          },
        };
      }
      case FETCH_USERS_PAGE_SUCCESS: {
        const { pageKey, users, hasMore, lastKey, append } = action.payload;
        const current = state.usersPage[pageKey] || emptyUsersPageBucket();
        return {
          ...state,
          usersPage: {
            ...state.usersPage,
            [pageKey]: {
              items: append ? [...current.items, ...users] : users,
              hasMore,
              lastKey,
              loading: false,
              error: null,
            },
          },
        };
      }
      case FETCH_USERS_PAGE_FAILED: {
        const { pageKey, msg } = action.payload;
        const current = state.usersPage[pageKey] || emptyUsersPageBucket();
        return {
          ...state,
          usersPage: {
            ...state.usersPage,
            [pageKey]: {
              ...current,
              loading: false,
              error: msg,
            },
          },
        };
      }
      case PATCH_USER_IN_LIST:
        return patchUserInLists(state, action.payload);
      case REMOVE_USER_FROM_LIST:
      case DELETE_USER_SUCCESS:
        return removeUserFromLists(state, action.payload);
      case EDIT_USER:
        return state;
      case DELETE_USER_FAILED:
        return {
          ...state,
          loading: false,
          error: {
            flag: true,
            msg: action.payload
          }
        };
      case CLEAR_USERS_ERROR:
        return {
          ...state,
          error: {
            flag: false,
            msg: null
          }
        };
      default:
        return state;
    }
  };
